import React from "react";
import PropTypes from "prop-types";
import "./styles.scss";

export default function SelectLocation({
  locations = [],
  businessName = "",
  isDisabled = true,
  isProcessing,
  /*eslint-disable-next-line*/
  renderBusinessNameField = renderBusinessNameField,
  onBusinessNameChange,
  onLocationSelect,
  onEnterLocationManually,
  onFocus
}) {
  return (
    <div className={"SelectLocation-container"}>
      {renderBusinessNameField(businessName, isDisabled, onBusinessNameChange, onFocus)}
      {locations && !isProcessing
        ? makeLocationsList(
            locations,
            onLocationSelect,
            onEnterLocationManually
          )
        : null}
    </div>
  );
}

function makeLocationsList(
  locations = [],
  onLocationSelect,
  onEnterLocationManually
) {
  return (
    <div
      className={"SelectLocation-locationsListContainer"}
      data-hook={"locationsList"}
    >
      <div className={"SelectLocation-locationsList"}>
        {locations.length > 0
          ? locations.map((location, index) => (
              <div key={index}>
                {makeLocationItem(location, onLocationSelect)}
              </div>
            ))
          : makeNoLocationsFound(onEnterLocationManually)}
      </div>
      {locations.length > 0 ? (
        <div
          className={"SelectLocation-locationsListFooter"}
          data-hook={"locationsListFooter"}
        />
      ) : null}
    </div>
  );
}

function makeLocationItem(location, onLocationSelect) {
  return (
    <div
      className={"SelectLocation-locationItem"}
      data-hook={"locationItem"}
      onClick={() => onLocationSelect(location)}
    >
      <div className={"SelectLocation-locationItemInside"}>
        <div
          className={"SelectLocation-locationName"}
          data-hook={"locationName"}
        >
          <strong>{location.name}</strong>
        </div>
        <div
          className={"SelectLocation-locationAddress"}
          data-hook={"locationAddress"}
        >
          {location.address}
        </div>
      </div>
    </div>
  );
}

function makeNoLocationsFound(onEnterLocationManually) {
  return (
    <div
      data-hook={"noLocationsFound"}
      className={"SelectLocation-noLocationsFound"}
    >
      <div className={"SelectLocation-nothingFound"}>Nothing found&hellip;</div>
      {false && (
        <div>
          <button
            type={"button"}
            onClick={onEnterLocationManually}
            data-hook={"enterManuallyButton"}
          >
            Enter Manually
          </button>
        </div>
      )}
    </div>
  );
}

/**
 * Render Business Name field.
 * @param {String} businessName - business name field value
 * @param {Boolean} isDisabled - flag that make business name field disabled
 * @param {Function} onBusinessNameChange - callback that fires when value of business name field changed
 * @param {Function} onFocus - action on focus
 * @return {React.Element}
 */
function renderBusinessNameField(
  businessName = "",
  isDisabled = false,
  onBusinessNameChange,
  onFocus
) {
  return (
    <input
      className={"SelectLocation-businessNameField"}
      type={"text"}
      placeholder={"Start typing your business name and address..."}
      value={businessName}
      disabled={isDisabled}
      onChange={event => onBusinessNameChange(event.target.value)}
      onFocus={onFocus}
      data-hook={"findYourBusinessField"}
    />
  );
}

SelectLocation.propTypes = {
  businessName: PropTypes.string,
  isDisabled: PropTypes.bool,
  isProcessing: PropTypes.bool,
  locations: PropTypes.array,
  onBusinessNameChange: PropTypes.func,
  onEnterLocationManually: PropTypes.func,
  onLocationSelect: PropTypes.func,
  renderBusinessNameField: PropTypes.func
};

SelectLocation.defaultProps = {
  businessName: "",
  isDisabled: true,
  locations: [],
  renderBusinessNameField: renderBusinessNameField
};
